function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import AmountField from '../../presentational/vt/amount-field';
import React from 'react';
import { connect } from 'react-redux';

var AmountFieldContainer = /*#__PURE__*/function (_React$Component) {
  _inherits(AmountFieldContainer, _React$Component);

  var _super = _createSuper(AmountFieldContainer);

  function AmountFieldContainer(props) {
    var _this;

    _classCallCheck(this, AmountFieldContainer);

    _this = _super.call(this, props);

    _this.exponent = function (terminalCurrency) {
      var currencyExponents = {
        BHD: 3,
        BIF: 0,
        BYR: 0,
        CLF: 4,
        CLP: 0,
        DJF: 0,
        GNF: 0,
        IQD: 3,
        ISK: 0,
        JOD: 3,
        JPY: 0,
        KMF: 0,
        KWD: 3,
        LYD: 3,
        OMR: 3,
        PYG: 0,
        RWF: 0,
        TND: 3,
        UGX: 0,
        VND: 0,
        VUV: 0,
        XAF: 0,
        XOR: 0,
        XPF: 0,
        ZMK: 0
      };
      return currencyExponents[terminalCurrency] || 2;
    };

    _this.updateDecimalAmountFor = function (exponent, decimalValue) {
      var decimalAmountValue = decimalValue + '0000';
      var truncatedValue = decimalAmountValue.substring(0, exponent);
      return truncatedValue;
    };

    _this.onWholeAmountChange = function (event) {
      var value = event.target.value;

      _this.setState({
        wholeAmountValue: value
      });
    };

    _this.onDecimalAmountChange = function (event) {
      var value = event.target.value;

      _this.decimalAmountValidation(value);

      _this.setState({
        decimalAmountValue: value
      });
    };

    _this.remainingAmountRadioChange = function (changeEvent) {
      var isRemaining = changeEvent.target.id === 'input_amount_remaining';

      if (isRemaining) {
        _this.setState({
          remainingAmountOption: 'remaining'
        });

        return;
      }

      _this.setState({
        customAmountOption: 'custom'
      });
    };

    _this.decimalAmountValidation = function (decimalAmountValue) {
      var terminalExponent = _this.state.terminalSelected ? _this.exponent(_this.props.terminalCurrency) : 2;
      var regex = new RegExp("\\d{".concat(terminalExponent, "}"));

      if (decimalAmountValue.match(regex)) {
        _this.setState({
          decimalFieldError: false
        });
      } else {
        _this.setState({
          decimalFieldError: true
        });
      }
    };

    _this.showRemainingAmountOptions = function (terminalSelected, splitPaymentTrx, withRequiredReferenceId) {
      return terminalSelected && Boolean(splitPaymentTrx) || withRequiredReferenceId && !splitPaymentTrx;
    };

    var _this$props = _this.props,
        amount = _this$props.amount,
        supportsRemainingAmount = _this$props.supportsRemainingAmount,
        _terminalCurrency = _this$props.terminalCurrency,
        virtualTerminalSelected = _this$props.virtualTerminalSelected,
        saleOperatorCurrency = _this$props.saleOperatorCurrency;
    _this.state = {
      wholeAmountValue: amount[0] === null ? '0' : amount[0],
      decimalAmountValue: amount[1] === null ? '00' : amount[1],
      decimalFieldError: false,
      remainingAmountOption: 'remaining',
      customAmountOption: '',
      supportsRemainingAmount: supportsRemainingAmount,
      terminalCurrency: _terminalCurrency || saleOperatorCurrency,
      terminalSelected: virtualTerminalSelected
    };
    return _this;
  }

  _createClass(AmountFieldContainer, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.terminalCurrency !== this.props.terminalCurrency) {
        var newDecimalAmount = this.updateDecimalAmountFor(this.exponent(this.props.terminalCurrency), this.state.decimalAmountValue);
        this.setState({
          terminalCurrency: this.props.terminalCurrency,
          decimalAmountValue: newDecimalAmount,
          terminalSelected: true
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          wholeAmountValue = _this$state.wholeAmountValue,
          decimalAmountValue = _this$state.decimalAmountValue,
          decimalFieldError = _this$state.decimalFieldError,
          remainingAmountOption = _this$state.remainingAmountOption,
          supportsRemainingAmount = _this$state.supportsRemainingAmount,
          terminalCurrency = _this$state.terminalCurrency,
          terminalSelected = _this$state.terminalSelected,
          customAmountOption = _this$state.customAmountOption;
      var _this$props2 = this.props,
          exponent = _this$props2.exponent,
          managedRecurring = _this$props2.managedRecurring,
          terminalSplitPayments = _this$props2.terminalSplitPayments,
          disabled = _this$props2.disabled,
          withRequiredReferenceId = _this$props2.withRequiredReferenceId;
      return React.createElement(AmountField, {
        onWholeAmountChange: this.onWholeAmountChange,
        onDecimalAmountChange: this.onDecimalAmountChange,
        wholeAmountValue: wholeAmountValue,
        decimalAmountValue: decimalAmountValue,
        exponent: exponent,
        decimalFieldError: decimalFieldError,
        remainingAmountRadioChange: this.remainingAmountRadioChange,
        remainingAmountOption: remainingAmountOption,
        customAmountOption: customAmountOption,
        supportsRemainingAmount: supportsRemainingAmount,
        splitPaymentTrx: terminalSplitPayments.visible,
        terminalCurrency: terminalCurrency,
        managedRecurring: managedRecurring,
        disabled: disabled,
        terminalSelected: terminalSelected,
        withRequiredReferenceId: withRequiredReferenceId,
        showRemainingAmountOptions: this.showRemainingAmountOptions
      });
    }
  }]);

  return AmountFieldContainer;
}(React.Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    virtualTerminalSelected: state.virtualTerminalState.isFetched,
    terminalCurrency: state.virtualTerminalFormData.terminalCurrency,
    terminalSplitPayments: state.virtualTerminalFormData.split_payments
  };
};

AmountFieldContainer.defaultProps = {
  amount: ['0', '00'],
  disabled: false,
  supportsRemainingAmount: false,
  managedRecurring: false,
  terminalCurrency: '',
  terminalSplitPayments: {
    visible: false
  },
  saleOperatorCurrency: ''
};
export default connect(mapStateToProps)(AmountFieldContainer);